<div class="restore-wrapper">
  <div class="auth-bg"></div>

  <div class="auth-content">
    <div class="brand-header">
      <img src="assets/logo.png" alt="Porra Mundial 2026" class="brand-logo" />
      <span class="brand-name">PORRA MUNDIAL 2026</span>
    </div>

    <div class="auth-card">
      <div class="auth-card-inner">
        <h2 class="form-title">
          {{ code ? 'Nueva contraseña' : 'Recuperar acceso' }}
        </h2>
        <p class="form-subtitle">
          {{ code ? 'Elige una contraseña nueva para tu cuenta.' : 'Te enviaremos un enlace a tu email.' }}
        </p>

        <div class="field-group">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Email</mat-label>
            <input matInput type="email" autocomplete="email" [(ngModel)]="username" />
          </mat-form-field>

          @if (code) {
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Nueva contraseña</mat-label>
              <input type="password" matInput autocomplete="new-password" [(ngModel)]="password" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Repetir contraseña</mat-label>
              <input type="password" matInput autocomplete="new-password" [(ngModel)]="confirmPassword" />
            </mat-form-field>
          }
        </div>

        @if (!code) {
          <button mat-flat-button color="primary" class="btn-cta" (click)="reset()">
            Enviar enlace
          </button>
        }
        @if (code) {
          <button mat-flat-button color="primary" class="btn-cta" (click)="restore()">
            Guardar contraseña
          </button>
        }

        <div class="form-links">
          <button mat-button routerLink="/login" class="link-btn">
            Volver al inicio de sesión
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<block-ui></block-ui>
